import * as getters from '@/store/modules/join/createAccount/getters'
import * as mutations from '@/store/modules/join/createAccount/mutations'
import * as actions from '@/store/modules/join/createAccount/actions'

const state = {
    processStepsInfo: [],
    literaryAbilities: [],
    maritalStatuses: [],
    countries: [],
    provinces: [],
    counties: [],
    provinceCounties: [], /* Counties filtered by province */
    processOccupation: [],
    professions: [],
    professionalActivities: [],
    contractualTies: [],
    provincesAgencies: [],
    branches: []
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
